export default function slider({ variables }) {
    return {
        MuiSlider: {
            styleOverrides: {
                root: {
                    color: variables.interactive,
                    "&.Mui-disabled": {
                        "& .MuiSlider-markLabel": {
                            color: variables.text_disabled,
                        },
                    },
                },
                rail: {
                    borderRadius: variables.border_radius_pill,
                },
                track: {
                    border: "none",
                    borderRadius: variables.border_radius_pill,
                },
                valueLabel: {
                    borderRadius: variables.border_radius_small,
                    backgroundColor: variables.interactive,
                },
                mark: {
                    backgroundColor: variables.interactive_muted,
                    opacity: 0.38,
                },
                markLabel: {
                    color: variables.text_primary,
                },
                disabled: {
                    color: variables.text_disabled,
                },
            },
        },
    };
}
//# sourceMappingURL=slider.js.map